import Vue from "vue";
import axios from "axios";
import {reactive, toRefs, computed, provide, inject} from "@vue/composition-api";
import {topic} from "../../api";
import {capitalize} from "../../plugins/formatting";
import {$t} from "@/i18n";
import {updateListState} from "../store_helpers";

export const state = reactive({
    map: new Map(),
    list: []
});

export const actions = {
    async fetchAllTopics() {
        try {
            state.list = [];
            state.list = await topic.get();
        } catch (err) {
            console.error("fetchAllTopics", err);
        }
    },
    fetchAccountTopics(account_id) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/a/{0}/topics/".format(account_id))
                .then(function (resp) {
                    state.map = new Map(resp.data.map(i => [i.id, i]));
                    state.list = resp.data;
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveTopic(data) {
        return new Promise(function (resolve, reject) {
            let topic_id = data.id ? data.id : "";
            axios
                .post(Vue.config.url_prefix + "/api/topics/{0}".format(topic_id), data)
                .then(function (resp) {
                    updateListState(resp.data.id, resp.data, state.list, "id", true);
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteTopic(topic_id, raise_error) {
        return new Promise(function (resolve, reject) {
            let params = {
                raise_error: raise_error
            }
            axios
                .delete(Vue.config.url_prefix + "/api/topics/{0}".format(topic_id), {params: params})
                .then(function () {
                    updateListState(topic_id, null, state.list);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    }
};

export const getters = {
    topics: computed(() => state.list),
    all_topics: computed(() => state.list),

    getTopic: id => computed(() => {
        return state.list.find(x => x.id === Number(id)) || {id: null};
    }),
    getTopicName: id => computed(() => {
        const topic = state.list.find(x => Number(x.id) === Number(id));
        if (topic) {
            return capitalize(topic["name"].toLowerCase());
        }
        return "invalid input";
    }),
    merged_topics: computed(() => {
        // fixme :: topic refactor
        return getters.topics.value;
    }),
};

export const key = Symbol("TopicModule");

export const provideTopic = () => {
    provide(key, {
        ...toRefs(state),
        ...toRefs(getters),
        ...actions
    });
};

export default () => inject(key);
